/* ============================================================
   STRUKT — mystery-popup.js
   "Choose a tile" mystery discount. Shows once per browser
   (localStorage), waits a few seconds, and holds the close (X)
   back for a few more seconds.

   Flow: pick a tile -> it lifts to reveal the prize -> enter email
   to redeem -> real /contact form submit (page reload) -> thank-you.
   The code itself is never shown on site: it's emailed. The prize
   is saved as a customer tag (e.g. mystery-10-off) so an email
   automation can send the matching code.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var STORAGE_KEY = 'strukt_mystery_popup_seen';
  var SUB_KEY = 'strukt_mystery_popup_subscribed';
  var PILL_KEY = 'strukt_mystery_pill_dismissed';
  var PRIZE_KEY = 'strukt_mystery_prize';

  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  var root = qs('[data-mystery-popup]');
  if (!root) return;

  var config = window.mysteryPopupConfig || { showDelay: 2, closeDelay: 3, prizes: [] };
  var prizes = (config.prizes || []).filter(function (p) { return p && p.label; });

  /* Shopify appends ?customer_posted=true after a successful form submit. */
  var justSubscribed = /[?&]customer_posted=true\b/.test(window.location.search);
  if (justSubscribed && window.history && window.history.replaceState) {
    var cleanUrl = window.location.pathname + window.location.search.replace(/[?&]customer_posted=true\b/, '').replace(/^&/, '?') + window.location.hash;
    window.history.replaceState(null, '', cleanUrl);
  }

  function flag(key) { try { return window.localStorage.getItem(key) === '1'; } catch (e) { return false; } }
  function setFlag(key) { try { window.localStorage.setItem(key, '1'); } catch (e) {} }
  function getPrize() { try { return window.localStorage.getItem(PRIZE_KEY) || ''; } catch (e) { return ''; } }
  function setPrize(v) { try { window.localStorage.setItem(PRIZE_KEY, v); } catch (e) {} }
  if (justSubscribed) setFlag(SUB_KEY);

  var alreadySeen = flag(STORAGE_KEY);
  var pill = qs('[data-mystery-pill]');
  var closeBtn = qs('[data-mystery-close]', root);
  var overlay = qs('[data-mystery-overlay]', root);
  var stepPick = qs('[data-mystery-step="pick"]', root);
  var stepClaim = qs('[data-mystery-step="claim"]', root);
  var stepDone = qs('[data-mystery-step="reveal"]', root);
  var tilesWrap = qs('[data-mystery-tiles]', root);
  var tiles = qsa('[data-mystery-tile]', root);
  var claimHeading = qs('[data-mystery-claim-heading]', root);
  var doneText = qs('[data-mystery-reveal-text]', root);
  var tagsInput = qs('[data-mystery-tags]', root);
  var emailInput = qs('[data-mystery-email]', root);
  var picking = false;

  function fill(template, prize) { return String(template || '').replace(/\{prize\}/g, prize); }
  function slug(label) { return label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  function showStep(name) {
    [[stepPick, 'pick'], [stepClaim, 'claim'], [stepDone, 'reveal']].forEach(function (pair) {
      if (pair[0]) pair[0].hidden = pair[1] !== name;
    });
  }

  function applyPrize(label) {
    if (claimHeading) claimHeading.textContent = fill(claimHeading.getAttribute('data-template'), label);
    if (doneText) doneText.textContent = fill(doneText.getAttribute('data-template'), label);
    if (tagsInput) tagsInput.value = 'newsletter,mystery-discount,mystery-' + slug(label);
  }

  function drawPrize() {
    var total = prizes.reduce(function (sum, p) { return sum + Math.max(0, Number(p.weight) || 0); }, 0);
    if (!prizes.length) return '';
    if (total <= 0) return prizes[0].label;
    var roll = Math.random() * total;
    for (var i = 0; i < prizes.length; i++) {
      roll -= Math.max(0, Number(prizes[i].weight) || 0);
      if (roll < 0) return prizes[i].label;
    }
    return prizes[prizes.length - 1].label;
  }

  function markSeen() { setFlag(STORAGE_KEY); }

  function pillLabel() {
    var btn = pill && qs('[data-mystery-pill-open]', pill);
    var text = pill && qs('[data-mystery-pill-text]', pill);
    if (!btn || !text) return;
    var prize = getPrize();
    text.textContent = prize ? fill(btn.getAttribute('data-claim-template'), prize) : btn.getAttribute('data-label');
  }

  function hidePill() {
    if (!pill) return;
    pill.classList.remove('is-visible');
    pill.hidden = true;
  }

  function showPill() {
    if (!pill || flag(SUB_KEY) || flag(PILL_KEY)) return;
    pillLabel();
    pill.hidden = false;
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { pill.classList.add('is-visible'); }); });
  }

  function open(instant) {
    hidePill();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    doc.body.classList.add('mystery-popup-open');
    if (instant === true) {
      if (closeBtn) closeBtn.classList.add('is-visible');
    } else {
      setTimeout(function () {
        if (closeBtn) closeBtn.classList.add('is-visible');
      }, config.closeDelay * 1000);
    }
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    doc.body.classList.remove('mystery-popup-open');
    markSeen();
    showPill();
  }

  /* Choose the right starting step: already picked a prize -> go straight to redeem. */
  function startStep() {
    var prize = getPrize();
    if (prize) {
      applyPrize(prize);
      showStep('claim');
    } else {
      showStep('pick');
    }
  }

  function pickTile(tile) {
    if (picking || !prizes.length) return;
    picking = true;
    var label = drawPrize();
    setPrize(label);
    applyPrize(label);
    var prizeEl = qs('[data-mystery-tile-prize]', tile);
    if (prizeEl) prizeEl.textContent = label;
    if (tilesWrap) tilesWrap.classList.add('is-picked');
    tiles.forEach(function (t) { t.classList.add(t === tile ? 'is-revealed' : 'is-dimmed'); t.disabled = true; });
    /* let the lift + glow play, then move on to the email step */
    setTimeout(function () {
      showStep('claim');
      if (emailInput) { try { emailInput.focus({ preventScroll: true }); } catch (e) {} }
    }, 1700);
  }

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () { pickTile(tile); });
  });

  if (justSubscribed) {
    markSeen();
    applyPrize(getPrize() || 'discount');
    showStep('reveal');
    open();
    if (closeBtn) closeBtn.classList.add('is-visible');
  } else if (alreadySeen) {
    startStep();
    showPill();
  } else {
    startStep();
    setTimeout(open, config.showDelay * 1000);
  }

  if (pill) {
    var pillOpen = qs('[data-mystery-pill-open]', pill);
    var pillClose = qs('[data-mystery-pill-close]', pill);
    if (pillOpen) {
      pillOpen.addEventListener('click', function () {
        startStep();
        open(true);
      });
    }
    if (pillClose) {
      pillClose.addEventListener('click', function () {
        setFlag(PILL_KEY);
        hidePill();
      });
    }
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      if (!closeBtn.classList.contains('is-visible')) return;
      close();
    });
  }
  if (overlay) {
    overlay.addEventListener('click', function () {
      if (closeBtn && closeBtn.classList.contains('is-visible')) close();
    });
  }
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && closeBtn && closeBtn.classList.contains('is-visible')) close();
  });
})();
